import { MainSocketService } from "@/services/main-socket-service";
import { ActiveUser } from "./active-user";

export class ActiveUsersList {
	private items:ActiveUser[] = [];

	public constructor(users:ActiveUser[]){
		this.onUserDisconnected = this.onUserDisconnected.bind(this);
		this.addUsers(users);
		MainSocketService.on("/metrics/user-connected", (data:any)=>{
			let user = new ActiveUser(data);
			this.addUser(user);
		}, this);
	}

	public addUser(user:ActiveUser){
		let index = this.items.findIndex(u=>u.id == user.id);
		if (index == -1){
			this.items.push(user);
			MainSocketService.on(`/metrics/user-disconnected/${user.id}`, this.onUserDisconnected, this);
		}else{
			this.items[index].SessionCount = user.SessionCount;
		}
	}

	private onUserDisconnected(data:any){
		let user = new ActiveUser(data);
		let index = this.items.findIndex(u=>u.id == user.id);
		if (index == -1) {
			if (user.SessionCount == 0) {
				return;
			}
			this.addUser(user);
			return;
		};
		if (user.SessionCount == 0) {
			this.items.splice(index, 1);
			MainSocketService.off(`/metrics/user-disconnected/${user.id}`, this.onUserDisconnected, this);
		}else{
			this.items[index].SessionCount = user.SessionCount;
		}
	}

	public addUsers(users:ActiveUser[]){
		for (let user of users){
			this.addUser(user);
		}
	}

	public destroy(){
		MainSocketService.offAll(this);
	}

	public getUsers():ActiveUser[]{
		return [...this.items];
	}
}